// extracted by mini-css-extract-plugin
export default {"loginDiv":"base_loginDiv__xvMMz","logoContainer":"base_logoContainer__hAplK","loginForm":"base_loginForm__xiOqC"};